export const AUTHENTICATION_TYPE = {
    MESSAGE_BASED: 'message_based',
};
